module.exports = __webpack_public_path__ + "img/size.019cfc12.png";